/**
 * Component to define the limits of an adjustable clothrail. E.g the clothrail can be moved
 * between the min and max limits.
 * The limits are defined in the meta data and set by component resolver.
 */
class AdjustableClothrailLimitsComponent {
    constructor(min, max) {
        this.typeId = AdjustableClothrailLimitsComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.min = min;
        this.max = max;
    }
    eq(_other) {
        return this.min !== _other.min || this.max !== _other.max;
    }
}
AdjustableClothrailLimitsComponent.id = 3003;
export default AdjustableClothrailLimitsComponent;
//# sourceMappingURL=AdjustableClothrailLimitsComponent.js.map